import _ from 'lodash';
import { routeDefinitions } from '../../../common/routing';

// We use a predefined set of routes and their tags to generate
// the area tag. The system also accounts for wildcard values
// in the URL patterns (for example /content/:id)
const _compiledRoutes = routeDefinitions.map(([pattern, area]) => {
  const keys = [];

  const regexStr = pattern.replace(/\/:([^/?]+)(\?)?/g, (_, key, optional) => {
    keys.push(key);
    return optional ? '(?:/([^/]+))?' : '/([^/]+)';
  });
  return { regex: new RegExp(`^/?${regexStr}$`), keys, area };
});

const _getAreaFromUrl = _.memoize((pathname) => {
  for (const { regex, keys, area } of _compiledRoutes) {
    const match = pathname.match(regex);
    if (!match) continue;

    const params = keys.reduce((acc, key, i) => {
      acc[key] = match[i + 1];
      return acc;
    }, {});

    const segments = typeof area === 'function' ? area(params) : area;
    return segments.join(' > ');
  }
  return 'untracked path';
});

const getEventTags = (event) => ({
  ...event.tags,
  product:     'grow',
  app_version: App.globalContext?.ngxCoreappVersion,
  environment: App.globalContext?.sentryService?.environment,
  area:        _getAreaFromUrl(window.location.pathname),
  userEmail:   App.globalContext.user.email,
});

export { getEventTags };
